import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import offlineMapsSrc from './images/offline-maps-thumb.avif';

const unlimitedMapDownloads = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Unlimited Map Downloads' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Download trails, parks, and areas to stay on route without cell signal' }),
  thumbnailImage: offlineMapsSrc.src
});

export default unlimitedMapDownloads;
